var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRevenueEvent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F3F0F6",
    d: "M0 0h23v23H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.756 11.442h.684c.67 0 1.164-.111 1.483-.335.319-.223.478-.574.478-1.052 0-.474-.164-.812-.492-1.012-.323-.2-.827-.3-1.51-.3h-.643v2.7zm0 1.723V17h-2.12V7.006h2.913c1.358 0 2.363.248 3.014.745.652.492.978 1.242.978 2.249 0 .588-.162 1.112-.485 1.572-.324.456-.782.814-1.374 1.074A402.632 402.632 0 0016.622 17H14.27l-2.386-3.835h-1.128z",
    fill: "#9B6DCF"
  })));
}
export default SvgRevenueEvent;